export default __webpack_public_path__ + "static/Group-148811-a03f71bd205a11dfa59428fbd2e626cd.png";